import "element-plus/dist/index.css";
import "./styles/global.css";

import { createApp } from "vue";
import App from "./App.vue";

import store from "@/store";
import router from "@/router";

import ElementPlus from "element-plus";

import http from "@/http";
import i18n from "@/i18n/i18n";
import moment from "moment";
import CKEditor from "@ckeditor/ckeditor5-vue";

const app = createApp(App);

app.config.globalProperties.$http = http;
app.config.globalProperties.$moment = moment;

app.use(store);
app.use(router);
app.use(i18n);
app.use(ElementPlus);
app.use(CKEditor);

app.mount("#app");
